import { DeleteOutline, DragIndicator, Edit, Save } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
import useDraggable from "hooks/DragAndDrop/useDraggable";
import { useState } from "react";
import getTextForCharacterLimit from "utils/getTextForCharacterLimit";
import { OPTION_DND_TYPE } from "../ScriptQuestions";

interface Props {
  option: string;
  index: number;
  onDelete: (index: number) => void;
  onEdit: (option: string, index: number) => void;
}

export const OPTION_DELIMITER = "::";

export default function QuestionOption({
  option,
  index,
  onDelete,
  onEdit,
}: Props) {
  const [editedOption, setEditedOption] = useState(option);
  const [isEditing, setIsEditing] = useState(false);
  const draggableProps = useDraggable({
    dndType: OPTION_DND_TYPE,
    index,
    item: option,
  });

  return (
    <Box
      ref={draggableProps.ref}
      sx={({ borders, palette, functions }) => ({
        borderRadius: borders.borderRadius.xl,
        display: "flex",
        alignItems: "center",
        span: { flex: 1 },
        backgroundColor: palette.common.white,
        color: palette.grey[800],
        mb: functions.pxToRem(4),
      })}
    >
      <IconButton>
        <DragIndicator />
      </IconButton>
      {isEditing ? (
        <TextField
          name="questionOptions"
          value={editedOption}
          onChange={(event) => {
            setEditedOption(
              event.target.value.replaceAll(OPTION_DELIMITER, ":"),
            );
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter" && editedOption !== "") {
              setIsEditing(false);
              onEdit(editedOption, index);
            }
          }}
          onBlur={(e) => {
            if (e.target.value) {
              setIsEditing(false);
              onEdit(editedOption, index);
            }
          }}
          label={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>
                {getTextForCharacterLimit(250, editedOption.length || 0)}
              </span>
            </Box>
          }
          type="text"
          inputProps={{ maxLength: 250 }}
        />
      ) : (
        <span>{option}</span>
      )}
      <IconButton size="small" color="error" onClick={() => onDelete(index)}>
        <DeleteOutline />
      </IconButton>
      <IconButton
        size="small"
        color="primary"
        onClick={() => setIsEditing(!isEditing)}
      >
        {!isEditing ? <Edit /> : <Save />}
      </IconButton>
    </Box>
  );
}
